import AbstractViewManage from '@/class/view/AbstractViewManage'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { cache } from '@/utils/cacheManager'
import { queryIsInsured } from '@/api/external/insure'
import $store from '@/store'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export class CommonHAWBPM extends AbstractViewManage {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }

  async fillView() {
    const job = this.job
    if (job) {
      const paymentTermList = await getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm)
      const paymentTerm = paymentTermList.find(p => p.code === job.paymentTermHBL)
      if (paymentTerm) {
        this.view.freightTerm = paymentTerm.name
      } else {
        this.view.freightTerm = ''
      }
    }
    if (this.form) {
      this.form.currency = this.form.currency === 'RMB' ? 'CNY' : this.form.currency
    }
    this.view.$refs.part1.fillView()
  }
  // reset 收发通地址
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperId = null
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = null
        break
      case 2:
        this.form.consigneeId = null
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = null
        break
      case 3:
        this.form.notifyId = null
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = null
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
  // 单号抄录回调函数
  transcribeEnterHandler(cargoDoc) {
    if (cargoDoc) {
      this.form.shipperCode = cargoDoc.shipperCode
      this.form.shipperLine1 = cargoDoc.shipperLine1
      this.form.shipperLine2 = cargoDoc.shipperLine2
      this.form.shipperLine3 = cargoDoc.shipperLine3
      this.form.shipperLine4 = cargoDoc.shipperLine4
      this.form.shipperLine5 = cargoDoc.shipperLine5
      this.form.shipperLine6 = cargoDoc.shipperLine6
      this.form.consigneeCode = cargoDoc.consigneeCode
      this.form.consigneeLine1 = cargoDoc.consigneeLine1
      this.form.consigneeLine2 = cargoDoc.consigneeLine2
      this.form.consigneeLine3 = cargoDoc.consigneeLine3
      this.form.consigneeLine4 = cargoDoc.consigneeLine4
      this.form.consigneeLine5 = cargoDoc.consigneeLine5
      this.form.consigneeLine6 = cargoDoc.consigneeLine6
      this.form.notifyCode = cargoDoc.notifyCode
      this.form.notifyLine1 = cargoDoc.notifyLine1
      this.form.notifyLine2 = cargoDoc.notifyLine2
      this.form.notifyLine3 = cargoDoc.notifyLine3
      this.form.notifyLine4 = cargoDoc.notifyLine4
      this.form.notifyLine5 = cargoDoc.notifyLine5
      this.form.notifyLine6 = cargoDoc.notifyLine6
      this.form.notifyLine7 = cargoDoc.notifyLine7
    }
  }
  // 抄录主单信息
  copyMblCargoDoc() {
    if (!this.job) return
    this.$confirm(this.view.$t('AirImport.AreCopyTheMastersInformation'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      closeOnClickModal: false,
      type: 'warning'
    }).then(async() => {
      const mawb = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
      if (mawb) {
        this.form.shipperCode = mawb.shipperCode
        this.form.shipperLine1 = mawb.shipperLine1
        this.form.shipperLine2 = mawb.shipperLine2
        this.form.shipperLine3 = mawb.shipperLine3
        this.form.shipperLine4 = mawb.shipperLine4
        this.form.shipperLine5 = mawb.shipperLine5
        this.form.shipperLine6 = mawb.shipperLine6
        this.form.consigneeCode = mawb.consigneeCode
        this.form.consigneeLine1 = mawb.consigneeLine1
        this.form.consigneeLine2 = mawb.consigneeLine2
        this.form.consigneeLine3 = mawb.consigneeLine3
        this.form.consigneeLine4 = mawb.consigneeLine4
        this.form.consigneeLine5 = mawb.consigneeLine5
        this.form.consigneeLine6 = mawb.consigneeLine6
        this.form.notifyCode = mawb.notifyCode
        this.form.notifyLine1 = mawb.notifyLine1
        this.form.notifyLine2 = mawb.notifyLine2
        this.form.notifyLine3 = mawb.notifyLine3
        this.form.notifyLine4 = mawb.notifyLine4
        this.form.notifyLine5 = mawb.notifyLine5
        this.form.notifyLine6 = mawb.notifyLine6
        this.form.notifyLine7 = mawb.notifyLine7
      }
    })
  }
  executeTask() {
  }
  /**
   * 投保
   */
  async toInsure() {
    let hawbDoc = null
    for (const doc of this.job.airCargoDoc) {
      if (doc.docType === 'HAWB') {
        hawbDoc = doc
        break
      }
    }
    if (!hawbDoc) {
      this.view.$message.warning(this.view.$t('SeaExport.NoData'))
      return
    }
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: hawbDoc.uuid,
      billno: hawbDoc.hblNbr2,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(cache.config.get('isPlatformInsurance')) === 3) {
    //   let hawbDoc = null
    //   for (const doc of this.job.airCargoDoc) {
    //     if (doc.docType === 'HAWB') {
    //       hawbDoc = doc
    //       break
    //     }
    //   }
    //   if (!hawbDoc) {
    //     this.view.$message.warning(this.view.$t('SeaExport.NoData'))
    //     return
    //   }
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     docUuid: hawbDoc.uuid,
    //     billno: hawbDoc.hblNbr2,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (cache.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('AE-HAWB' + this.view.$t('SeaExport.Insure'))
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let hawb = null
    //   for (const doc of this.job.airCargoDoc) {
    //     if (doc.docType === 'HAWB') {
    //       hawb = doc
    //       break
    //     }
    //   }
    //   if (!hawb) {
    //     this.view.$message.warning(this.view.$t('SeaExport.NoData'))
    //     return
    //   }
    //   const jobCopy = { ... this.job }
    //   if (Object.prototype.hasOwnProperty.call(jobCopy, 'containerUsages')) {
    //     for (const usage of jobCopy.containerUsages) {
    //       delete usage.container
    //     }
    //   }
    //   if (Object.prototype.hasOwnProperty.call(jobCopy, 'containers')) {
    //     for (const container of this.job.containers) {
    //       delete container.containerUsages
    //     }
    //   }
    //   AirCargoDoc.toInsureForAi(hawb, jobCopy, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
}
